import React from "react";
import clsx from "clsx";
import { PreviewStepProps } from "interfaces/preview.interface";
import "./preview_step.component.scss";

const PreviewStep = (props: PreviewStepProps): React.ReactElement => {
    const { number, title, isPrimary = false, children } = props;

    return (
        <section className="preview_step">
            <h2 className="preview_step_heading">
                <span className={clsx("preview_step_number", isPrimary && "preview_step_number_primary")}>{number}</span>
                <span className="preview_step_title">{title}</span>
            </h2>
            {children}
        </section>
    );
};

export default PreviewStep;
